import React, { useState } from "react";
import {
  motion,
  AnimatePresence,
  useViewportScroll,
  useTransform,
} from "framer-motion";
import { Link as ScrollLink } from "react-scroll";
import { useNavigate } from "react-router-dom";
import CompetitionReserve from "./CompetitionReserve";

// -------------- LOGO & IMAGES --------------
import Logo from "../AllImages/GetItRight.png";
import Taxi from "../AllImages/CuteTaxi.png";
import nyskYLINE from "../AllImages/NewYorkSkyBridge.jpg";

// -------------- TOUR HIGHLIGHT IMAGES --------------
import MajesticConcert from "../AllImages/Concert.jpg";
import EmpireState from "../AllImages/Empire.png";
import TimesSquare from "../AllImages/Timetime.jpg";
import StatueOfLiberty from "../AllImages/StatueLiberty.jpg";
import Masterclass from "../AllImages/Intesene.jpg";
import ChrismasMarket from "../AllImages/ChristmasMarket.jpeg";

// -------------- STAFF IMAGES --------------
import Susan from "../AllImages/Susan.jpeg";
import Luis from "../AllImages/Luis.jpg";
import Ruben from "../AllImages/Rubenn.png";
import Jesus from "../AllImages/Jesus.jpeg";
import Cesar from "../AllImages/Cesar.png";

// -------------- OPTIONAL INSTRUMENT IMAGES --------------
import Violin from "../AllImages/Concert.jpg";
import Trumpet from "../AllImages/Concert.jpg";

// --------------------------------------------------
// FEATURES SECTION
// --------------------------------------------------
const FeaturesSection = () => {
  return (
    <section className="bg-white py-12" id="features">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-serif font-bold text-center mb-6 text-yellow-600">
        Discover the Elegance of New York
        </h2>
        <p className="text-lg text-center text-gray-700 mb-12">
        Travel through iconic landmarks, enjoy timeless symphonies, and embrace the refined festive spirit of a city renowned for its art and culture.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <motion.div
            className="p-6 bg-gray-50 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300"
            whileHover={{ scale: 1.02 }}
          >
            <h3 className="text-2xl font-serif font-semibold mb-4 text-yellow-500">
            Detailed Itinerary
            </h3>
            <p className="text-gray-600">
            Explore New York’s most iconic landmarks — from majestic concert halls to world-renowned theaters — with our carefully crafted itinerary.

            </p>
          </motion.div>

          <motion.div
            className="p-6 bg-gray-50 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300"
            whileHover={{ scale: 1.02 }}
          >
            <h3 className="text-2xl font-serif font-semibold mb-4 text-blue-500">
            Music & Performances
            </h3>
            <p className="text-gray-600">
            Sign up with ease, organize your plans, and manage your itinerary through our intuitive online portal.

            </p>
          </motion.div>

          <motion.div
            className="p-6 bg-gray-50 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300"
            whileHover={{ scale: 1.02 }}
          >
            <h3 className="text-2xl font-serif font-semibold mb-4 text-indigo-500">
            Simple Registration
            </h3>
            <p className="text-gray-600">
            Sign up with ease, organize your plans, and manage your itinerary through our intuitive online portal.

            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

// --------------------------------------------------
// CONCERT REPERTOIRE SECTION
// --------------------------------------------------
const ConcertRepertoireSection = () => {
  return (
    <section id="repertoire" className="py-12 bg-gray-100 text-center">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-serif font-bold mb-6 text-yellow-700">
        Repertorio del Concierto
        </h2>
        <ul className="list-disc list-inside text-left max-w-xl mx-auto text-gray-700 space-y-2">
          <li>
            "We Wish You a Merry Christmas" – A festive classic to start the
            celebration.
          </li>
          <li>
            "Jingle Bell Rock" – A cheerful, upbeat holiday favorite.
          </li>
          <li>
            "White Christmas" – A timeless melody evoking the magic of the season.
          </li>
          <li>
            "Original Composition" – An exclusive piece written for this special
            tour.
          </li>
          <li>
            "Carol of the Bells" – A powerful, iconic arrangement full of energy.
          </li>
          <li>
            "Emmanuel" – A serene and reflective holiday hymn.
          </li>
          <li>
            "A Christmas Festival" – A vibrant medley celebrating the joy of
            Christmas.
          </li>
          <li>
            "Feliz Navidad" – A lively, international Christmas classic to close
            the show.
          </li>
        </ul>
      </div>
    </section>
  );
};

// --------------------------------------------------
// EXCLUSIVE AIRLINE DEALS SECTION (MOVED AFTER CONCERT REPERTOIRE)
// --------------------------------------------------
const AirlineDealsSection = () => {
  return (
    <section
      id="airline-deals"
      className="py-20 bg-gray-900 text-white text-center relative overflow-hidden"
    >
      <div className="max-w-3xl mx-auto px-4">
        {/* Heading with airplanes on either side */}
        <motion.h2
          className="text-4xl md:text-5xl font-bold mb-4 drop-shadow-lg font-serif flex items-center justify-center"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <span className="text-4xl md:text-5xl text-yellow-300 mr-2">✈️</span>
          Exclusive Airline Deals
          <span className="text-4xl md:text-5xl text-yellow-300 ml-2">✈️</span>
        </motion.h2>

        {/* Paragraph */}
        <motion.p
          className="text-lg md:text-xl mb-8 font-medium text-gray-200 leading-relaxed"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
          viewport={{ once: true }}
         >
   Simanof has partnered with various airlines to offer exclusive flight deals — special promotions you won’t find anywhere else online, as this is an educational tour. To get the best ticket options, please contact us at{" "}
 {" "}
          <a
            href="mailto:Information@simanof.org"
            className="text-yellow-400 underline"
          >
            Information@simanof.org
          </a>{" "}
          or call us at{" "}
          <a
            href="tel:7737109953"
            className="text-yellow-400 underline"
          >
            773-710-9953
          </a>.
        </motion.p>

        {/* CTA Button */}
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="bg-yellow-500 text-black font-bold px-8 py-3 rounded-full shadow-xl hover:bg-yellow-400 transition-colors"
          onClick={() => (window.location = "mailto:Information@simanof.org")}
        >
       Get Your Deal Now
        </motion.button>
      </div>
    </section>
  );
};

// --------------------------------------------------
// TOUR HIGHLIGHTS SECTION
// --------------------------------------------------
const tourHighlightsData = [
  {
    id: 1,
    title: "Majestic Concert",
    description:
    "Immerse yourself in the grandeur of a Christmas concert at a historic Manhattan venue, filled with timeless symphonies and festive melodies.",
    image: MajesticConcert,
  },
  {
    id: 2,
    title: "Empire State of Mind",
    description:
    "Ascend the iconic Empire State Building and enjoy breathtaking panoramic views of the city — capturing the heart of New York from above.",
    image: EmpireState,
  },
  {
    id: 3,
    title: "Times Square Lights",
    description:
    "Feel the electric atmosphere of Times Square, buzzing with lights, billboards, and unstoppable vibrant energy.",
    image: TimesSquare,
  },
  {
    id: 4,
    title: "Statue of Liberty Tourd",
    description:
    "Sail to Liberty Island and witness the emblem of American freedom — an unforgettable journey into NYC’s historic past.",
    image: StatueOfLiberty,
  },
  {
    id: 5,
    title: "Masterclass Workshop",
    description:
    "Elevate your musical technique with exclusive sessions led by world-class experts, shaping the future of orchestral performance.",
    image: Masterclass,
  },
  {
    id: 6,
    title: "Christmas Market",
    description:
    "Savor festive treats and handmade gifts at New York’s famous holiday markets, bursting with seasonal joy and charm.",
    image: ChrismasMarket,
  },
];

const TourHighlightsSection = () => {
  const [selectedHighlight, setSelectedHighlight] = useState(null);

  return (
    <section
      id="tour-highlights"
      className="py-12 bg-gray-200 text-center relative"
    >
      <div className="absolute top-5 left-5 text-6xl text-blue-900 opacity-20 select-none pointer-events-none">
        🎼
      </div>
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-serif font-bold mb-6 text-blue-900">
          Tour Highlights
        </h2>
        <p className="max-w-xl mx-auto text-gray-700 mb-8 px-4">
          Explore exclusive experiences and remarkable moments that capture the
          essence of NYC’s musical heritage.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 px-4">
          {tourHighlightsData.map((highlight) => (
            <motion.div
              key={highlight.id}
              className="bg-white rounded-lg shadow-lg overflow-hidden cursor-pointer transform transition-all hover:scale-105"
              onClick={() => setSelectedHighlight(highlight)}
            >
              <img
                src={highlight.image}
                alt={highlight.title}
                className="w-full h-48 object-cover"
              />
              <div className="p-4">
                <h3 className="text-xl font-serif font-semibold text-blue-600 mb-2">
                  {highlight.title}
                </h3>
                <p className="text-gray-700 text-sm">
                  {highlight.description.substring(0, 80)}...
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {selectedHighlight && (
          <motion.div
            className="fixed inset-0 flex items-center justify-center z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <div
              className="absolute inset-0 bg-black opacity-60"
              onClick={() => setSelectedHighlight(null)}
            />
            <motion.div
              className="bg-white rounded-lg shadow-2xl p-6 relative z-10 max-w-lg mx-auto"
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
            >
              <button
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                onClick={() => setSelectedHighlight(null)}
              >
                ✕
              </button>
              <img
                src={selectedHighlight.image}
                alt={selectedHighlight.title}
                className="w-full h-auto rounded-md mb-4"
              />
              <h3 className="text-2xl font-serif font-bold mb-2">
                {selectedHighlight.title}
              </h3>
              <p className="text-gray-700">{selectedHighlight.description}</p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

// --------------------------------------------------
// COMPETITION SECTION (UPDATED WITH MODAL)
// --------------------------------------------------
const CompetitionSection = () => {
  const [isReserveModalOpen, setReserveModalOpen] = useState(false);

  return (
    <section
      id="competition"
      className="relative py-20 bg-gradient-to-br from-gray-800 to-gray-900 text-white overflow-hidden"
    >
      <svg
        className="absolute top-0 left-0 w-full text-gray-900 fill-current"
        viewBox="0 0 1440 120"
        preserveAspectRatio="none"
      >
        <path d="M0,10 C120,30 240,60 360,60 C480,60 600,30 720,20 C840,10 960,20 1080,50 C1200,80 1320,110 1440,120 L1440,0 L0,0 Z"></path>
      </svg>
      <motion.img
        src={Violin}
        alt="Violin"
        className="absolute top-10 left-10 w-16 h-auto opacity-10"
        initial={{ rotate: 0 }}
        animate={{ rotate: 360 }}
        transition={{ duration: 50, repeat: Infinity, ease: "linear" }}
      />
      <motion.img
        src={Trumpet}
        alt="Trumpet"
        className="absolute bottom-10 right-10 w-20 h-auto opacity-10"
        initial={{ rotate: 0 }}
        animate={{ rotate: -360 }}
        transition={{ duration: 60, repeat: Infinity, ease: "linear" }}
      />
      <div className="relative z-10 max-w-6xl mx-auto px-4 text-center">
        <motion.h2
          className="text-4xl md:text-5xl font-bold mb-4 drop-shadow-lg"
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
NY Tour Grand Competition
        </motion.h2>
        <motion.p
          className="text-xl mb-12 font-semibold"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
          viewport={{ once: true }}
        >
       Unleash your talent and step into the spotlight! Win incredible prizes and the chance to be a soloist in our Japan 2026 Tour.
        </motion.p>
        <div className="flex justify-center items-end space-x-8">
          <motion.div
            className="flex flex-col items-center"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="w-44 bg-white bg-opacity-20 backdrop-blur-lg p-4 rounded-xl shadow-xl border-t-4 border-yellow-400 transform hover:scale-105 transition-transform">
              <h3 className="text-xl font-bold text-yellow-400">🥈 2nd Place</h3>
              <p className="text-md font-semibold">$700 + 10% Off</p>
              <p className="text-sm">All 2026 Simanof Tours</p>
            </div>
            <span className="mt-2 text-sm">2nd Place</span>
          </motion.div>

          <motion.div
            className="relative flex flex-col items-center"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="absolute -top-12 w-72 h-72 rounded-full bg-yellow-400 opacity-30 blur-xl z-[-1]" />
            <div className="w-56 h-auto bg-white bg-opacity-20 backdrop-blur-lg p-6 rounded-xl shadow-2xl border-t-4 border-yellow-500 transform hover:scale-105 transition-transform">
              <h3 className="text-2xl font-extrabold text-yellow-500">🥇 1st Place</h3>
              <p className="text-3xl font-extrabold text-green-400 mt-2">$2,200</p>
              <p className="text-md font-semibold mt-1">
                + 10% Off All 2026 Simanof Tours
              </p>
              <p className="text-sm mt-1">Soloist in Japan 2026</p>
            </div>
            <span className="mt-2 text-sm">1st Place</span>
          </motion.div>

          <motion.div
            className="flex flex-col items-center"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="w-44 bg-white bg-opacity-20 backdrop-blur-lg p-4 rounded-xl shadow-xl border-t-4 border-yellow-300 transform hover:scale-105 transition-transform">
              <h3 className="text-xl font-bold text-yellow-300">🥉 3rd Place</h3>
              <p className="text-md font-semibold">$100 + 10% Off</p>
              <p className="text-sm">All 2026 Simanof Tours</p>
            </div>
            <span className="mt-2 text-sm">3rd Place</span>
          </motion.div>
        </div>

        
        <p className="mt-8 text-sm text-gray-300 max-w-lg mx-auto leading-relaxed">
          <strong>Disclaimer:</strong> To participate in this competition, you must either be part of the Simanof Tour or participate in the Christmas Concert. If you are not part of the "Main Tour", you must sign up for the Christmas Concert by clicking on the button below.
        </p>
        <motion.button
          onClick={() => setReserveModalOpen(true)}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="mt-4 bg-yellow-500 text-black px-4 py-2 rounded-md hover:bg-yellow-400 transition-colors"
        >
          Sign Up Now
        </motion.button>



      </div>
      <AnimatePresence>
        {isReserveModalOpen && (
          <motion.div
            className="fixed inset-0 flex items-center justify-center z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <div
              className="absolute inset-0 bg-black opacity-60"
              onClick={() => setReserveModalOpen(false)}
            />
            <motion.div
              className="bg-white rounded-lg shadow-2xl p-6 relative z-10 max-w-lg mx-auto"
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
            >
              <button
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                onClick={() => setReserveModalOpen(false)}
              >
                ✕
              </button>
              <CompetitionReserve />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      <svg
        className="absolute bottom-0 left-0 w-full text-gray-900 fill-current"
        viewBox="0 0 1440 120"
        preserveAspectRatio="none"
      >
        <path d="M0,10 C120,30 240,60 360,60 C480,60 600,30 720,20 C840,10 960,20 1080,50 C1200,80 1320,110 1440,120 L1440,0 L0,0 Z"></path>
      </svg>
    </section>
  );
};

// --------------------------------------------------
// STAFF SECTION (OUR ESTEEMED ENSEMBLE)
// --------------------------------------------------
const staffData = [
  {
    name: "Susan Siman",
    role: "Founder of Simanof",
    image: Susan,
    bio: "Susan Siman is the founder of the Siman Orchestral Foundation and a tireless advocate for music education. With decades of experience as a teacher and mentor, she has inspired generations of young musicians through her passion, discipline, and firm belief in the transformative power of music. Her legacy lives on in every note played by the orchestras she has built around the world.",
  },
  {
    name: "Luis Ibarra",
    role: "Orchestra Conductor",
    image: Luis,
    bio: "Luis Ibarra is a distinguished conductor, celebrated for his powerful interpretations and inspiring leadership. With deep knowledge of the orchestral repertoire and a strong passion for education, he brings out the best in every ensemble he directs. His work with the Siman Orchestral Foundation has created unforgettable performances and nurtured the growth of young musicians across borders.",
  },
  {
    name: "Ruben Siman",
    role: "Executive Director",
    image: Ruben,
    bio: "Ruben Siman is the Executive Director of the Siman Orchestral Foundation, where he leads international music tours and creates transformative orchestral experiences for youth. Deeply committed to music education, he merges art and technology—building platforms for global competitions, real-time payments, and interactive learning. Ruben is also the visionary behind innovative projects like Muselight and continues to foster communities where music, education, and opportunity flourish beyond borders.",
 },
  {
    name: "Cesar Bollero",
    role: "Head of Security",
    image: Cesar,
    bio: "Cesar Bollero is the Head of Security for the Siman Orchestral Foundation, ensuring each tour and event runs safely and smoothly. With a calm presence and consistent professionalism, Cesar is a trusted figure for families, staff, and students alike. His commitment to safety and supportive spirit make him an essential part of the Simanof team.",
  },
  {
    name: "Jesus Azocar",
    role: "Tour Management Assistant",
    image: Jesus,
    bio: "Jesus Azocar is the Tour Management Assistant at the Siman Orchestral Foundation, bringing energy, precision, and dedication to every detail of the experience. Known for his commitment and ability to connect with both students and staff, Jesus plays a key role in making every journey successful and unforgettable for all involved.",
  },
];


const StaffSection = () => {
  const [selectedStaff, setSelectedStaff] = useState(null);

  return (
    <motion.section
      id="staff"
      className="relative py-12 bg-gray-100 text-center"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <div className="absolute top-5 right-5 text-6xl text-yellow-200 opacity-20 select-none pointer-events-none">
        🎼
      </div>
      <h2 className="text-2xl md:text-3xl font-serif font-bold mb-6">
      Our Esteemed Ensemble
      </h2>
      <p className="max-w-xl mx-auto text-gray-700 mb-8 px-4">
      Our world-class team—composed of directors, soloists, and dedicated staff—is committed to providing an unforgettable musical experience.
 </p>
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 px-4">
        {staffData.map((member, index) => (
          <div
            key={index}
            onClick={() => setSelectedStaff(member)}
            className="cursor-pointer bg-white p-6 rounded-lg shadow-md hover:shadow-2xl transition-shadow"
          >
            <img
              src={member.image}
              alt={member.name}
              className="w-32 h-32 object-cover rounded-full mx-auto mb-4"
            />
            <h3 className="text-xl font-serif font-semibold text-blue-600 mb-2">
              {member.name}
            </h3>
            <p className="text-gray-700">{member.role}</p>
          </div>
        ))}
      </div>

      <AnimatePresence>
        {selectedStaff && (
          <motion.div
            className="fixed inset-0 flex items-center justify-center z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <div
              className="absolute inset-0 bg-black opacity-60"
              onClick={() => setSelectedStaff(null)}
            />
            <motion.div
              className="bg-white rounded-lg shadow-2xl p-6 relative z-10 max-w-sm mx-auto"
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
            >
              <button
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                onClick={() => setSelectedStaff(null)}
              >
                ✕
              </button>
              <img
                src={selectedStaff.image}
                alt={selectedStaff.name}
                className="w-32 h-32 object-cover rounded-full mx-auto mb-4"
              />
              <h3 className="text-xl font-serif font-semibold text-blue-600 mb-2">
                {selectedStaff.name}
              </h3>
              <p className="text-gray-700 font-semibold">{selectedStaff.role}</p>
              <p className="text-gray-600 mt-4">{selectedStaff.bio}</p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.section>
  );
};

// --------------------------------------------------
// HOME PAGE COMPONENT
// --------------------------------------------------
const HomePage = () => {
  const navigate = useNavigate();
  const { scrollY } = useViewportScroll();
  const backgroundY = useTransform(scrollY, [0, 500], [0, -50]);
  const taxiY = useTransform(scrollY, [0, 500], [0, -120]);

  return (
    <div className="flex flex-col min-h-screen font-sans text-gray-800 relative">
      {/* HEADER */}
      <motion.header
        className="flex items-center justify-between p-4 bg-black shadow-md sticky top-0 z-50"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="flex items-center space-x-2">
          <img src={Logo} alt="Company Logo" className="h-10 w-auto" />
          <span className="text-xl font-serif font-bold text-yellow-500">
            NY Orchestral Tour
          </span>
        </div>
        <nav className="space-x-6 hidden md:block">
          <ScrollLink
            to="home"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            className="hover:text-yellow-400 transition-colors cursor-pointer text-white"
          >
       Home

          </ScrollLink>
          <ScrollLink
            to="features"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            className="hover:text-yellow-400 transition-colors cursor-pointer text-white"
          >
           About the Tour 
          </ScrollLink>
          <ScrollLink
            to="repertoire"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            className="hover:text-yellow-400 transition-colors cursor-pointer text-white"
          >
   Repertoire 
          </ScrollLink>
          <ScrollLink
            to="tour-highlights"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            className="hover:text-yellow-400 transition-colors cursor-pointer text-white"
          >
       Highlights

          </ScrollLink>
          <ScrollLink
            to="competition"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            className="hover:text-yellow-400 transition-colors cursor-pointer text-white"
          >
        Competition
          </ScrollLink>
          <ScrollLink
            to="staff"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            className="hover:text-yellow-400 transition-colors cursor-pointer text-white"
          >
       Our Ensemble 
          </ScrollLink>
          <ScrollLink
            to="contact"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            className="hover:text-yellow-400 transition-colors cursor-pointer text-white"
          >
      Contact
          </ScrollLink>
        </nav>
        <motion.button
          onClick={() => navigate("/TerminalPage")}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="bg-yellow-500 text-black px-4 py-2 rounded-md hover:bg-yellow-400 transition-colors"
        >
         Sign In
        </motion.button>
      </motion.header>

      {/* HERO SECTION */}
      <section
        id="home"
        className="relative flex items-center justify-center h-[70vh] bg-gray-800 overflow-hidden"
      >
        <motion.div style={{ y: backgroundY }} className="absolute inset-0 z-0">
          <img
            src={nyskYLINE}
            alt="NY Skyline"
            className="w-full h-full object-cover"
          />
        </motion.div>
        <motion.div style={{ y: taxiY }} className="absolute z-20 bottom-5 right-5">
          <img src={Taxi} alt="NYC Taxi" className="h-32 w-auto object-contain" />
        </motion.div>
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900 to-black opacity-40 z-30"></div>
        <motion.div
          className="relative z-40 text-center max-w-2xl mx-auto px-4"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4 drop-shadow-lg">
          Experience the Majestic Symphony of New York
          </h1>
          <p className="text-lg md:text-xl text-gray-200 mb-6">
          Join us on an exclusive tour through New York’s finest orchestral venues and unforgettable performances.
          </p>
          <motion.button
            onClick={() => navigate("/Onboard")}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bg-yellow-500 text-black font-semibold px-6 py-3 rounded-full shadow-lg hover:bg-yellow-400 transition-colors"
          >
             Register Now
          </motion.button>
        </motion.div>
      </section>

      {/* MAIN CONTENT SECTIONS */}
      <FeaturesSection />
      <ConcertRepertoireSection />
      <AirlineDealsSection />
      <TourHighlightsSection />
      <CompetitionSection />
      <StaffSection />

      {/* FOOTER */}
      <footer
        id="contact"
        className="mt-auto bg-gray-900 text-gray-300 py-6 px-4 relative"
      >
        <div className="absolute top-5 left-5 text-6xl text-yellow-200 opacity-20 select-none pointer-events-none">
          ♪
        </div>
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div>
            <h4 className="text-xl font-serif font-bold mb-2">
            NY Orchestral Tour – Simanof
            </h4>
            <p className="text-sm text-gray-400">
            Experience the timeless elegance and grandeur of New York’s musical legacy.
     
            </p>
          </div>
          <div className="flex space-x-6">
            <a
              href="https://www.facebook.com/profile.php?id=100063723403677"
              className="hover:text-yellow-400 transition-colors text-sm"
            >
              Facebook
            </a>
            <a
              href="https://www.youtube.com/@simanofusa"
              className="hover:text-yellow-300 transition-colors text-sm"
            >
              Youtube
            </a>
            <a
              href="https://www.instagram.com/siman_orchestral_foundation/"
              className="hover:text-yellow-400 transition-colors text-sm"
            >
              Instagram
            </a>
          </div>
          <div className="text-sm text-gray-400 text-center md:text-right">
            <p>Contact us: Information@Simanof.org</p>
            <p>Phone: +1 (773) 710 - 9953</p>
          </div>
        </div>
        <div className="text-center text-xs text-gray-600 mt-4">
          © 2025 Simanof NY Orchestral Tour. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
